export class UserHeaderProperties {
    public MainTitle: string;
}
